import React from 'react';

const PostageTable = ({ postages, onEdit }) => {
    return (
        <table className="table table-hover align-middle table-nowrap mb-0">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {postages && postages.map((postage, index) => (
                    <tr key={index}>
                        <td>
                            <div className="d-flex align-items-center flex-nowrap">
                                <p className="fw-semibold text-body-emphasis mb-0">
                                    {index + 1}
                                </p>
                            </div>
                        </td>
                        <td>{postage.name}</td>
                        <td>{postage.type}</td>
                        <td>
                            <button 
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => onEdit(postage)}
                            >
                                <i className='fa fa-pen'></i>
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default PostageTable;